import React from 'react';
import { Logo } from './Logo';
export function TopBar() {
  return <header className="sticky top-0 z-50 w-full border-b border-white/10 bg-ink/95 backdrop-blur" data-id="element-166" data-mp="3sf80b59zvfb9">
      <div className="mx-auto flex h-14 w-full max-w-6xl items-center justify-center px-5 sm:px-8" data-id="element-167" data-mp="1y3sosxsbcz4b">
        <a href="#top" aria-label="Flag Football Ready — back to top" className="rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-brand/50" data-id="element-168" data-mp="1t4pizb4ieova">
          <Logo data-id="element-169" data-mp="2ltelnel7r295" />
        </a>
      </div>
    </header>;
}